export enum Platform {
	DEFAULT = 'DEFAULT',
	EMRA_MATCH = 'EMRA_MATCH',
}
